import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Button, CircularProgress, Grid } from '@mui/material';

import { BUTTON_STYLES } from '../../../../../../theme/buttonStyles';

const ContractCardActions = ({ onViewPositions, onDeleteContract, isDeleting }) => (
  <Grid item display="flex" justifyContent="flex-end" gap={2}>
    <Button variant="outlined" onClick={onViewPositions} sx={BUTTON_STYLES.primaryLarge}>
      {LanguageConverterV2('contractCard.viewImpactedPositions')}
    </Button>
    <Button
      variant="outlined"
      onClick={onDeleteContract}
      disabled={isDeleting}
      sx={BUTTON_STYLES.danger}
      startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : null}
    >
      {LanguageConverterV2('contractCard.deleteContract')}
    </Button>
  </Grid>
);

ContractCardActions.propTypes = {
  onViewPositions: PropTypes.func.isRequired,
  onDeleteContract: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
};

export default ContractCardActions;
